export default __webpack_public_path__ + "static/media/marco.863c4c11.png";